(function () {
    'use strict';

    angular
        .module('app.shared')
        .filter('percentage', percentageFilterFactory);

    percentageFilterFactory.$inject = ['$filter'];
    function percentageFilterFactory($filter) {
        var numberfilter = $filter('number');
        return function percentFilter(number, fractionSize) {
            if (typeof (number) === 'string' || typeof (number) === 'number') {
                var result = numberfilter(number * 100, fractionSize);
            }
            return result ? result + '%' : result;
        }
    }
})();